module.exports = __webpack_public_path__ + "static/media/christmaslinkup-mobile.d02eeeb1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/christmaslinkup-mobile.jpg
// module id = 51
// module chunks = 0